import React from 'react';
import { ICabinData, ICabinProps } from '@interfaces/ship';
import { NextImage } from '../../atoms/image/image';
import { CabinModule } from './cabin-module/cabin-module';
import { StyledCabinWrapper, StyledSection, StyledCabinContainer } from './cabin.style';

export interface ICabinModuleProps extends ICabinProps {
    shipName: string;
}

export const Cabin = ({
    imgUrl,
    placeholder,
    description,
    cabinData,
    shipName,
    ...rest
}: ICabinModuleProps) => (
    <StyledSection>
        {/* TODO: hydration breaks with styled components, fix (hopefully) with styled components 5*/}
        <NextImage
            fill
            placeholder={placeholder}
            imgUrl={imgUrl}
            isBackground
            customContentStyle={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
            style={{
                objectFit: 'cover',
            }}
        >
            <StyledCabinContainer>
                <StyledCabinWrapper>
                    <CabinModule
                        {...rest}
                        description={formatCabinDesc(description, cabinData)}
                        shipName={shipName}
                    />
                </StyledCabinWrapper>
            </StyledCabinContainer>
        </NextImage>
    </StyledSection>
);

export const formatCabinDesc = (
    cabinDesc: string,
    {
        title,
        numberOfCabins: cabinCategories,
        decks,
        smallestSquare,
        biggestSquare,
        passengers,
    }: ICabinData,
) => {
    // any because I don't understand the ts error that fires below in the replace funct
    const replacementMap: any = {
        '[shipName]': title,
        '[cabinCategories]': cabinCategories,
        '[decks]': decks,
        '[passengers]': passengers,
        '[smallestSquare]': smallestSquare,
        '[biggestSquare]': biggestSquare,
    };

    return cabinDesc.replace(/\[(([A-Za-z0-9#]+\s?))+]/g, function (matched: string) {
        return replacementMap[matched];
    });
};
